export default __webpack_public_path__ + "static/media/P545_CoC.07a1873e.pdf";